<template>
  <div class="pop-alert" :class="`pop-${name}`">
      <div class="container">
          <div class="pop-header clearfix">
              <div class="f-left">알림</div>
              <div class="f-right">
                  <button type="button" class="pop-close" @click="onClose"><span class="blind">팝업닫기</span></button>
              </div>
          </div>
          <div class="pop-content">
              <p>
                  <span v-for="(msg, index) in msgBlocks" :key="index">
                    <br v-if="index > 0">{{msg}}
                  </span>
              </p>
              <button type="button" class="pop-close btn-sm-border" @click="onCancelEvent();">{{cancelTitle}}</button>
              <button type="button" class="pop-close" @click="onConfirmEvent();">{{confirmTitle}}</button>              
          </div>
      </div>
  </div>
</template>
<script>

export default {
  props: ['confirm'],
  data(){
      return{
          msgBlocks:[],
          confirmTitle:'확인',
          cancelTitle:'취소',
          confirmHandler:null,
          cancelHandler:null,
          name: "common-confirm"
      }
  },
  methods:{
    onCancelEvent:function(){
        this.closePopAlert()
        if(this.cancelHandler)
            this.cancelHandler();    
        this.initialize();
    },
    onConfirmEvent:function(e){
        this.closePopAlert()    
        if(this.confirmHandler)
            this.confirmHandler();
        this.initialize();
    },
    onClose() {
      this.closePopAlert();
      this.initialize();
    },
    initialize() {
      this.msgBlocks = [];
      this.confirmTitle = '확인';
      this.cancelTitle ='취소';
      this.confirmHandler = null;
      this.cancelHandler = null;
    },
    // show(comp, msg,confirmHandler,cancelHandler){
    //   // this.postMessage = msg;
    //   this.msg = msg
    //   if(confirmHandler)this.confirmHandler = confirmHandler;
    //   if(cancelHandler)this.cancelHandler = cancelHandler;

    //   if (this.name.length === 0) {
    //     this.name = comp.$options._componentTag.toLowerCase();
    //   }
      
    //   this.openPopAlert(this.name);
    // },

    show( msg,confirmHandler,cancelHandler, confirmText, cancelText){
      // this.postMessage = msg;
      this.msgBlocks = this.getMsgBlocks(msg);
      if(confirmHandler)this.confirmHandler = confirmHandler;
      if(cancelHandler)this.cancelHandler = cancelHandler;
      if (confirmText) this.confirmTitle = confirmText;
      if (cancelText) this.cancelTitle = cancelText;

      // if (this.name.length === 0) {
      //   this.name = comp.$options._componentTag.toLowerCase();
      // }
      
      this.openPopAlert(this.name);
    },

    // showConfirmTitle(msg,confirmHandler,cancelHandler,confirmTitle,cancelTitle){
    //   // this.postMessage = msg;
    //   this.msg = msg
    //   if(confirmHandler)this.confirmHandler = confirmHandler;
    //   if(cancelHandler)this.cancelHandler = cancelHandler;

    //   if(confirmTitle)this.confirmTitle = confirmTitle;
    //   if(cancelTitle)this.cancelTitle = cancelTitle;

    //   if (this.name.length === 0) {
    //     this.name = comp.$options._componentTag.toLowerCase();
    //   }

    //   this.openPopAlert(this.name);
    // }
    getMsgBlocks(msg) {
      if (!msg) return [];
      return msg.split("\n");
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/common/PopCommonConfirm.vue